import React, { useRef } from 'react';
var VeltAutocompleteOptionErrorIcon = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-option-error-icon", { ref: ref }, children));
};
export default VeltAutocompleteOptionErrorIcon;
